import { render, staticRenderFns } from "./InspectionAssign.vue?vue&type=template&id=4faa2747&scoped=true&"
import script from "./InspectionAssign.vue?vue&type=script&lang=js&"
export * from "./InspectionAssign.vue?vue&type=script&lang=js&"
import style0 from "./InspectionAssign.vue?vue&type=style&index=0&id=4faa2747&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faa2747",
  null
  
)

export default component.exports